import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function VerifyEmail() {
  const { token } = useParams();
  const [status, setStatus] = useState("loading"); // loading, success, error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(`${API}/auth/verify-email/${token}`);
        const data = await response.json();

        if (response.ok) {
          setStatus("success");
          setMessage("Your email has been verified successfully!");
        } else {
          setStatus("error");
          setMessage(data.detail || "Verification failed");
        }
      } catch (error) {
        setStatus("error");
        setMessage("An error occurred during verification");
      }
    };

    if (token) {
      verifyEmail();
    }
  }, [token]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <img src="/toolio-logo-new.png" alt="TOOLIO" className="h-12" />
          
        </Link>

        <Card className="border-border bg-card">
          <CardContent className="pt-6 text-center space-y-4">
            {status === "loading" && (
              <>
                <Loader2 className="w-16 h-16 text-primary mx-auto animate-spin" />
                <h2 className="font-heading text-2xl uppercase">Verifying...</h2>
                <p className="text-muted-foreground">Please wait while we verify your email</p>
              </>
            )}

            {status === "success" && (
              <>
                <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
                <h2 className="font-heading text-2xl uppercase">Email Verified!</h2>
                <p className="text-muted-foreground">{message}</p>
                <Link to="/login">
                  <Button className="btn-primary mt-4" data-testid="go-to-login-btn">
                    Continue to Login
                  </Button>
                </Link>
              </>
            )}

            {status === "error" && (
              <>
                <XCircle className="w-16 h-16 text-destructive mx-auto" />
                <h2 className="font-heading text-2xl uppercase">Verification Failed</h2>
                <p className="text-muted-foreground">{message}</p>
                <Link to="/register">
                  <Button variant="outline" className="mt-4" data-testid="try-again-btn">
                    Try Again
                  </Button>
                </Link>
              </>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
